The draft position profile for the given `id`.
